export default __webpack_public_path__ + "static/miracle-8eebaddcb4a54c7d1fdd1297cf0e5e0b.png";